import { render, staticRenderFns } from "./SecurityIncident.vue?vue&type=template&id=04adac59&"
import script from "./SecurityIncident.vue?vue&type=script&lang=js&"
export * from "./SecurityIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports